import React from "react";
import LayoutPortalContext, { LayoutPortalState } from "./LayoutPortalContext";

export type LayoutPortalProviderProps = React.PropsWithChildren<{
  value: LayoutPortalState;
}>;

function LayoutPortalProvider(props: LayoutPortalProviderProps) {
  const { children, value } = props;

  return (
    <LayoutPortalContext.Provider value={value}>
      {children}
    </LayoutPortalContext.Provider>
  );
}

export default LayoutPortalProvider;
